export default function quantityColor (quantity, lower_limit) {
  return Number(quantity) < Number(lower_limit) ? 'warning-text' : ''
}
